import { DeleteForever, ExpandLess, ExpandMore, ImportantDevices, Microwave, Print, Restaurant, Tv } from "@mui/icons-material";
import React, { useEffect, useRef, useState } from "react";

import { Button, Checkbox, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, InputLabel, Link, List, ListItemButton, ListItemIcon, ListItemText, MenuItem, Select, TextField, Typography, colors } from "@mui/material";
import { addPrinter, generateDeviceToken, getdeviceInfo, removeDevice } from "../../hooks/apiHandler";
import TokenPopup from "./TokenPopup";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

const getConType = (typeCode) => {
  switch (typeCode) {
    case 0: return { label: "IP", color: "#2196f3" };
    case 1: return { label: "USB", color: "#43a047" };
    case 2: return { label: "SHARE", color: "#b261e5ff" };
    default: return { label: "Unknown", color: "default" };
  }
};

export const DeviceSetting = () => {

    const navigate = useNavigate();
    var storeID = useRef(JSON.parse(window.localStorage.getItem('ds')));
    const { Logout } = useAuth();
    const [reloadFlag, setReloadFlag] = useState(false);
    const [deviceInfo, setDeviceInfo] = useState();
    const [printDialog, setPrinterDialog] = useState({
        dialog: false,
        name: '',
        mm: '',
        mode: 0,
        port: '',
        cd: false
    });
    const [dialogInput, setDialogInput] = useState({
        dialog: false,
        deviceType: '',
        deviceid: ''
    });
    const [listAct, setListAct] = useState({
        screen: false,
        printer: false,
        cashDrawer: false,
        scanner: false,
        cscreen: false,
        kds: false,
    });

    useEffect(() => {
        console.log(storeID.current)
        async function calldeviceList() {
            var response = await getdeviceInfo({ storeID: storeID.current }, Logout);
            setDeviceInfo(await response.data);
        }
        calldeviceList()
        setReloadFlag(false);
        return () => {
            // this is same as component unmount of leaving the page..
        }
    }, [reloadFlag, Logout]);

    const [token, setToken] = useState({
        open: false,
        time: 0,
        token: ''
    });
    return (
        // <BasicPage title="Printer Settings" icon={<PrintSharp />} />
        <div>
            <List>
                <li key={'screens'}>
                    <ListItemButton onClick={() => setListAct(prev => ({ ...prev, screen: !listAct.screen }))}>
                        <ListItemIcon>
                            <ImportantDevices />
                        </ListItemIcon>
                        <ListItemText primary={`Screens (${(deviceInfo) ? deviceInfo.devices.length : '0'})`} autoCapitalize="true" />
                        <Button
                            onClick={
                                async () => {
                                    // console.log('This is called to generate Token..');
                                    var response = await generateDeviceToken({ storeID: storeID.current }, Logout);
                                    // console.log(response);
                                    if (response.code === 0) {
                                        console.log('token Card');
                                        console.log(response.data);
                                        setToken({ token: response.data.token, open: true, time: response.data.time });
                                    }
                                }
                            }
                            variant="outlined" >+ Add Screen</Button>
                        &ensp;&ensp;&nbsp;
                        {listAct.screen ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={listAct.screen} timeout="auto" unmountOnExit key={`collapse-`}>
                        <List disablePadding>
                            {(deviceInfo) ? (
                                deviceInfo.devices.map((item, index) => (
                                    <li key={'sc-' + index}>
                                        <ListItemButton sx={{ pl: 4 }} key={`nest-`} >
                                            <ListItemIcon>
                                                <Restaurant />
                                            </ListItemIcon>
                                            <ListItemText primary={item.name} secondary={
                                                <div>
                                                    <Grid container>
                                                        <Grid item xs={12} md={4}>
                                                            <Typography variant="body1" color="textSecondary">
                                                                {item.hid}
                                                            </Typography>
                                                            <Typography variant="body2" color="textSecondary">
                                                                <strong>Device Version : </strong> {item.os}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} md={4}>
                                                            <Typography variant="body2" color="textSecondary">
                                                                <strong>Token expire in : </strong> 20 days:temp
                                                            </Typography>
                                                            <Link onClick={() => {
                                                                console.log('Advance Link is Clicked');
                                                                navigate('/admin/deviceAdvSet', {
                                                                    state: {
                                                                        name: item.name,
                                                                        id: item._id,
                                                                        storeid: storeID.current
                                                                    }
                                                                });
                                                            }}> Advance Settings</Link>
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            } />
                                            <IconButton
                                                onClick={async () => {
                                                    setDialogInput({ dialog: true, deviceType: 'devices', deviceid: item._id });
                                                }}
                                            >
                                                <DeleteForever style={{ color: colors.orange[900] }} />
                                            </IconButton>
                                        </ListItemButton>
                                    </li>))) : ''}
                        </List>
                    </Collapse>
                </li>
                <li key={'printers'}>
                    <ListItemButton onClick={() => setListAct(prev => ({ ...prev, printer: !listAct.printer }))}>
                        <ListItemIcon>
                            <Print />
                        </ListItemIcon>
                        <ListItemText primary={`printers (${(deviceInfo) ? deviceInfo.printers.length : '0'})`} autoCapitalize="true" />
                        <Button
                            onClick={
                                () => setPrinterDialog({ ...printDialog, dialog: true })
                            }
                            variant="outlined" >+ Add Printer</Button>
                        &ensp;&ensp;&nbsp;
                        {listAct.printer ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={listAct.printer} timeout="auto" unmountOnExit key={`collapse-`}>
                        <List disablePadding>
                            {(deviceInfo?.printers.length > 0) ? (
                                deviceInfo.printers.map((item, index) => {
                                    const conType = getConType(item.mode);
                                    return (
                                    <li key={'pr-' + index}>
                                        <ListItemButton sx={{ pl: 4 }} key={`nest-`} >
                                            <ListItemIcon>
                                                <Restaurant />
                                            </ListItemIcon>
                                            <ListItemText primary={item.name} secondary={
                                                <div>
                                                    <Typography variant="body1" color="textSecondary">
                                                        {item.mm}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        <strong>Connection Type : &nbsp; </strong> 
                                                        <span style={{ color: conType.color, fontWeight: 'bold' }}>{conType.label}</span>
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        <strong>Port : </strong> {item.port}
                                                    </Typography>
                                                </div>
                                            } />
                                            <IconButton
                                                onClick={async () => {
                                                    setDialogInput({ dialog: true, deviceType: 'printers', deviceid: item._id });
                                                }}
                                            >
                                                <DeleteForever style={{ color: colors.orange[900] }} />
                                            </IconButton>
                                        </ListItemButton>
                                    </li>)})) : <li key={'pr-default'}>Add printer to the system</li>}
                        </List>
                    </Collapse>
                </li>
                {/* <li key={'cashdrawer'}>
                    <ListItemButton onClick={() => setListAct(prev => ({ ...prev, cashDrawer: !listAct.cashDrawer }))}>
                        <ListItemIcon>
                            <Payments />
                        </ListItemIcon>
                        <ListItemText primary={`Cash Drawers (${(deviceInfo) ? deviceInfo.scanners.length : '0'})`} autoCapitalize="true" />
                        <Button
                            onClick={
                                async () => {
                                    // console.log('This is called to generate Token..');
                                }
                            }
                            variant="outlined" >+ Add Drawer</Button>
                        &ensp;&ensp;&nbsp;
                        {listAct.cashDrawer ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={listAct.cashDrawer} timeout="auto" unmountOnExit key={`collapse-`}>
                        <List disablePadding>
                            {(deviceInfo?.scanners.length > 0) ? (
                                deviceInfo.scanners.map((item, index) => (
                                    <li key={'cd-' + index}>
                                        <ListItemButton sx={{ pl: 4 }} key={`nest-`} >
                                            <ListItemIcon>
                                                <Restaurant />
                                            </ListItemIcon>
                                            <ListItemText primary={item.name} secondary={
                                                <div>
                                                    <Typography variant="body1" color="textSecondary">
                                                        {item.hid}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        <strong>Device Modal : </strong> {item.os}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        <strong>Token expire in : </strong> 20 days
                                                    </Typography>
                                                </div>
                                            } />
                                            <IconButton
                                                onClick={() => {
                                                    alert('remove device ')
                                                }}
                                            >
                                                <DeleteForever style={{ color: colors.orange[900] }} />
                                            </IconButton>
                                        </ListItemButton>
                                    </li>))) : <li key={'cd-default'}><ListItemText>Need to check with the system working..</ListItemText></li>}
                        </List>
                    </Collapse>
                </li>
                <li key={'Scanner'}>
                    <ListItemButton onClick={() => setListAct(prev => ({ ...prev, scanner: !listAct.scanner }))}>
                        <ListItemIcon>
                            <QrCodeScanner />
                        </ListItemIcon>
                        <ListItemText primary={`Scanners (${(deviceInfo) ? deviceInfo.scanners.length : '0'})`} autoCapitalize="true" />
                        <Button
                            onClick={
                                async () => {
                                    // console.log('This is called to generate Token..');

                                }
                            }
                            variant="outlined" >+ Add Scanner</Button>
                        &ensp;&ensp;&nbsp;
                        {listAct.scanner ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={listAct.scanner} timeout="auto" unmountOnExit key={`collapse-`}>
                        <List disablePadding>
                            {(deviceInfo) ? (
                                deviceInfo?.scanners.map((item, index) => (
                                    <li key={'sca-' + index}>
                                        <ListItemButton sx={{ pl: 4 }} key={`nest-`} >
                                            <ListItemIcon>
                                                <Restaurant />
                                            </ListItemIcon>
                                            <ListItemText primary={item.name} secondary={
                                                <div>
                                                    <Typography variant="body1" color="textSecondary">
                                                        {item.hid}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        <strong>Device Modal : </strong> {item.os}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        <strong>Token expire in : </strong> 20 days
                                                    </Typography>
                                                </div>
                                            } />
                                            <IconButton
                                                onClick={() => {
                                                    alert('remove device ')
                                                }}
                                            >
                                                <DeleteForever style={{ color: colors.orange[900] }} />
                                            </IconButton>
                                        </ListItemButton>
                                    </li>))) : <li key={'sca-default'}>No Scanner Found</li>}
                        </List>
                    </Collapse>
                </li> */}
                <li key={'CliScreen'}>
                    <ListItemButton onClick={() => setListAct(prev => ({ ...prev, cscreen: !listAct.cscreen }))}>
                        <ListItemIcon>
                            <Tv />
                        </ListItemIcon>
                        <ListItemText primary={`Client Screen (${(deviceInfo) ? deviceInfo.cls.length : '0'})`} autoCapitalize="true" />
                        <Button
                            onClick={
                                async () => {
                                    // console.log('This is called to generate Token..');

                                }
                            }
                            variant="outlined" >+ Add Screen</Button>
                        &ensp;&ensp;&nbsp;
                        {listAct.cscreen ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={listAct.cscreen} timeout="auto" unmountOnExit key={`collapse-`}>
                        <List disablePadding>
                            {(deviceInfo) ? (
                                deviceInfo?.cls.map((item, index) => (
                                    <li key={'cls-' + index}>
                                        <ListItemButton sx={{ pl: 4 }} key={`nest-`} >
                                            <ListItemIcon>
                                                <Restaurant />
                                            </ListItemIcon>
                                            <ListItemText primary={item.name} secondary={
                                                <div>
                                                    <Typography variant="body1" color="textSecondary">
                                                        {item.hid}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        <strong>Device Modal : </strong> {item.os}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        <strong>Token expire in : </strong> 20 days
                                                    </Typography>
                                                </div>
                                            } />
                                            <IconButton
                                                onClick={async () => {
                                                    setDialogInput({ dialog: true, deviceType: 'cls', deviceid: item._id });
                                                }}
                                            >
                                                <DeleteForever style={{ color: colors.orange[900] }} />
                                            </IconButton>
                                        </ListItemButton>
                                    </li>))) : <li key={'cls-default'}>No Scanner Found</li>}
                        </List>
                    </Collapse>
                </li>
                <li key={'kds'}>
                    <ListItemButton onClick={() => setListAct(prev => ({ ...prev, kds: !listAct.kds }))}>
                        <ListItemIcon>
                            <Microwave />
                        </ListItemIcon>
                        <ListItemText primary={`Kitchen Display (${(deviceInfo) ? deviceInfo.kds.length : '0'})`} autoCapitalize="true" />
                        <Button
                            onClick={
                                async () => {
                                    // console.log('This is called to generate Token..');

                                }
                            }
                            variant="outlined" >+ Add Scanner</Button>
                        &ensp;&ensp;&nbsp;
                        {listAct.kds ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={listAct.kds} timeout="auto" unmountOnExit key={`collapse-`}>
                        <List disablePadding>
                            {(deviceInfo) ? (
                                deviceInfo?.kds.map((item, index) => (
                                    <li key={'kds-' + index}>
                                        <ListItemButton sx={{ pl: 4 }} key={`nest-`} >
                                            <ListItemIcon>
                                                <Restaurant />
                                            </ListItemIcon>
                                            <ListItemText primary={item.name} secondary={
                                                <div>
                                                    <Typography variant="body1" color="textSecondary">
                                                        {item.hid}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        <strong>Device Modal : </strong> {item.os}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                        <strong>Token expire in : </strong> 20 days
                                                    </Typography>
                                                </div>
                                            } />
                                            <IconButton
                                                onClick={async () => {
                                                    setDialogInput({ dialog: true, deviceType: 'kds', deviceid: item._id });
                                                }}
                                            >
                                                <DeleteForever style={{ color: colors.orange[900] }} />
                                            </IconButton>
                                        </ListItemButton>
                                    </li>))) : <li key={'kds-default'}>No kds Found</li>}
                        </List>
                    </Collapse>
                </li>
            </List>
            {token.open ? <TokenPopup
                token={token.token}
                countdownTime={token.time}
                onTokenExpire={() => {
                    setToken({}) // also call device list...
                    setReloadFlag(true);
                }}
            /> : ''}
            <Dialog open={dialogInput.dialog} onClose={() => { setDialogInput({ dialog: false, deviceid: '' }) }}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to remove device?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setDialogInput({ dialog: false, deviceid: '' }) }}>Cancel</Button>
                    <Button onClick={async () => {
                        console.log('Try to delete userID: ', dialogInput.deviceid);
                        var resp = await removeDevice({
                            storeID: storeID.current,
                            deviceType: dialogInput.deviceType,
                            id: dialogInput.deviceid
                        }, Logout);
                        setDeviceInfo(resp.data);
                        //finally 
                        setDialogInput({ dialog: false, deviceid: '' });
                    }} variant="contained" color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Following is to set printerDialog */}
            <Dialog
                open={printDialog.dialog}
                onClose={() => setPrinterDialog({
                    dialog: false,
                    name: '',
                    mm: '',
                    mode: 0,
                    port: '',
                    cd: false
                })}
            >

                {/* Welcome to Printer Dialog to Handle Priter to the System... */}
                <DialogTitle>Add Printer</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Add Printer and set IP And USB port
                    </DialogContentText>
                    <Grid container spacing={1}>
                        <FormControl variant="standard" sx={{ m: 1, minWidth: '100%' }}>
                            <TextField
                                autoFocus
                                required
                                margin="dense"
                                id="Printername"
                                name="printerName"
                                label="Name"
                                value={printDialog.name}
                                placeholder=" Kitchen Printer | Terminal 1"
                                type="text"
                                onChange={(e) => setPrinterDialog({ ...printDialog, name: e.target.value })}
                                fullWidth
                                variant="standard"
                            />
                        </FormControl>
                        {/* Need to add dropdown to select the printer */}
                        <FormControl variant="standard" sx={{ m: 1, minWidth: '100%' }}>
                            <InputLabel id="select-printer-label">Printer</InputLabel>
                            <Select
                                labelId="select-printer-label"
                                id="select-printer"
                                margin="dense"
                                value={printDialog.mm}
                                onChange={(e) => setPrinterDialog({ ...printDialog, mm: e.target.value })}
                                label="Type"
                                required
                            >
                                <MenuItem value="" disabled>
                                    <em>None</em>
                                </MenuItem>
                                <MenuItem value="star-micronics">Star Printers</MenuItem>
                                <MenuItem value="windows">Windows Default</MenuItem>

                            </Select>
                        </FormControl>
                        <Grid item xs={4} md={3}>
                            <FormControl variant="standard" sx={{ m: 1, minWidth: '100%' }}
                            >
                                <InputLabel id="demo-simple-select-standard-label">Type</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    margin="dense"
                                    value={printDialog.mode}
                                    onChange={(e) => setPrinterDialog({ ...printDialog, mode: e.target.value })}
                                    label="Type"
                                    required
                                    sx={{
                                        '& .MuiSelect-select': {
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            fontSize: '1rem', // default
                                            maxWidth: '100%',
                                            display: 'block',
                                        },
                                    }}
                                >
                                    <MenuItem value={0}>IP</MenuItem>
                                    <MenuItem value={1}>USB</MenuItem>
                                    <MenuItem value={2}>SHARED</MenuItem>

                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <FormControl variant="standard" sx={{ m: 1, minWidth: '100%' }}>
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="printerPort"
                                    name="port"
                                    label="Port"
                                    value={printDialog.port}
                                    placeholder=" COM5 | 192.168.1.1 | /shareName"
                                    type="text"
                                    onChange={(e) => setPrinterDialog({ ...printDialog, port: e.target.value })}
                                    fullWidth
                                    variant="standard"
                                />
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControlLabel control={<Checkbox checked={printDialog.cd} onChange={(event) => setPrinterDialog({ ...printDialog, cd: event.target.checked })} />} label="Cash Drawer " />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setPrinterDialog({
                        dialog: false,
                        name: '',
                        mm: '',
                        mode: 0,
                        port: '',
                        cd: false
                    })}>Cancel</Button>
                    <Button
                        type="submit"
                        onClick={async () => {
                            const { name, mm, port } = printDialog;
                            // Validate required fields
                            if (!name.trim() || !mm.trim() || !port.trim()) {
                                alert("Please fill in all required fields.");
                                return;
                            }
                            // Proceed to submit
                            const { dialog: _, ...sendData } = printDialog;
                            try {
                                const resp = await addPrinter({
                                    storeID: storeID.current,
                                    ...sendData,
                                }, Logout);

                                console.log(resp);
                                setDeviceInfo(await resp.data);

                                // Reset form
                                setPrinterDialog({
                                    dialog: false,
                                    name: '',
                                    mm: '',
                                    mode: 0,
                                    port: '',
                                    cd: false
                                });
                                /// incase response is not Proper with can reload data using Following
                                // setReloadFlag(true); // this is conneceted to useEffect any change in data to this object will referesk
                            } catch (error) {
                                console.error("Error adding printer:", error);
                            }
                        }}
                    >
                        ADD
                    </Button>

                </DialogActions>
            </Dialog>
        </div>
    )
}
